const ISO_DATE_LENGTH = 10;

function formatDate(date: string): string {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const arr = date.slice(0, ISO_DATE_LENGTH).split('-');
  const year = arr[0];
  const month = Number(arr[1]);
  const day = arr[2];
  return `${day} ${months[month - 1]}, ${year}`;
}

export { formatDate };
